<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row no-gutters>
      <v-col cols="12">
        <table class="divTable text-caption">
          <tr class="divTableHeading">
            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.User') }}
            </th>

            <!--
            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.Recipient') }}
            </th>
            -->

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.Type.Title') }}
            </th>

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.Via') }}
            </th>

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.OrderStatus') }}
            </th>

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.CreatedAt') }}
            </th>

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.DeliveredAt') }}
            </th>

            <th class="divTableHead text-center">
              {{ $t('Order.OrderDetailsDialog.Notification.ReadAt') }}
            </th>
          </tr>

          <template v-for="(item, itemIdx) in notificationsList">
            <tr
              :key="`transaction-${item.Id}${item.Timestamp}-${itemIdx}`"
              class="divTableRow"
            >
              <td class="divTableCell text-center text-no-wrap">
                <user-chip
                  v-if="item.User"
                  :color="item.UserColor"
                  :full-name="item.User"
                  :short-name="item.UserShortName"
                />
              </td>

              <td class="divTableCell text-center text-no-wrap">
                <v-chip
                  v-if="item.NotificationType"
                  :color="$te(`Order.OrderDetailsDialog.Notification.Type.Item.${item.NotificationType}.name`) ? $t(`Order.OrderDetailsDialog.Notification.Type.Item.${item.NotificationType}.color`) : 'grey darken-2'"
                  class="px-2 justify-center"
                  dark
                  label
                  small
                  style="min-width: 80px;"
                >
                  {{
                    $te(`Order.OrderDetailsDialog.Notification.Type.Item.${item.NotificationType}.name`) ? $t(`Order.OrderDetailsDialog.Notification.Type.Item.${item.NotificationType}.name`) : item.NotificationType.toLocaleUpperCase($i18n.locale)
                  }}
                </v-chip>
              </td>

              <td class="divTableCell text-center text-no-wrap">
                <v-tooltip
                  v-if="item.Type"
                  :color="item.Type === 'email' ? 'blue' : item.Type === 'sms' ? 'green' : item.Type === 'push' ? 'purple' : 'grey'"
                  right
                >
                  <template #activator="{on}">
                    <v-icon
                      :color="item.Type === 'email' ? 'blue' : item.Type === 'sms' ? 'green' : item.Type === 'push' ? 'purple' : 'grey'"
                      v-on="on"
                    >
                      {{ item.Type === 'email' ? 'mdi-email' : item.Type === 'sms' ? 'mdi-cellphone-message' : item.Type === 'push' ? 'mdi-cellphone-wireless' : '' }}
                    </v-icon>
                  </template>

                  <div>
                    <div class="text-center body-1">
                      {{ item.Type.toLocaleUpperCase($i18n.locale) }}
                    </div>

                    <div>{{ item.Subject || item.Message }}</div>
                  </div>
                </v-tooltip>
              </td>

              <td class="divTableCell text-center text-no-wrap">
                <order-status-chip
                  v-if="item.StatusId"
                  :min-width="135"
                  :order="item"
                  dense
                />
              </td>

              <td class="divTableCell text-center text-no-wrap">
                {{ item.CreatedAt }}
              </td>

              <td class="divTableCell text-center text-no-wrap">
                <v-tooltip
                  v-if="item.DeliveredAt"
                  color="success"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="success"
                      v-on="on"
                    >
                      mdi-email-check
                    </v-icon>
                  </template>

                  {{ item.DeliveredAt }}
                </v-tooltip>

                <v-tooltip
                  v-if="item.BouncedAt"
                  color="error"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="error"
                      v-on="on"
                    >
                      mdi-email-remove
                    </v-icon>
                  </template>

                  <div style="max-width: 200px">
                    <div>{{ item.BouncedAt }}</div>
                    <div class="text-caption mt-2">
                      {{ item.BounceMessage }}
                    </div>
                  </div>
                </v-tooltip>
              </td>

              <td class="divTableCell text-center text-no-wrap">
                <v-tooltip
                  v-if="item.ReadAt"
                  color="teal"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="teal"
                      v-on="on"
                    >
                      mdi-email-newsletter
                    </v-icon>
                  </template>

                  {{ item.ReadAt }}
                </v-tooltip>
              </td>
            </tr>
          </template>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import capitalize from '@/filters/string/capitalize'
import {getContrastColor} from '@/lib/color/index.js'
import StatusChip from '@/components/common/StatusChip.vue'
import OrderStatusChip from '@/components/orders/common/OrderStatusChip.vue'
import UserChip from '@/components/common/UserChip.vue'

export default {
  name      : 'OrderNotificationsTable',
  components: {UserChip, OrderStatusChip, StatusChip},
  directives: {},
  mixins    : [Auth, AppData],
  props     : {
    notifications: {
      type   : Array,
      default: () => []
    }
  },
  dataStore: {},
  data() {
    return {}
  },
  computed: {
    notificationsList() {
      return this.notifications || []
    },

    notificationsCount() {
      return this.notificationsList?.length || 0
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getContrastColor,
    capitalize
  }
}
</script>

<style scoped>

:deep(.v-speed-dial__list) {
  padding: 0;
}

.divTableCell.no-border {
  border-bottom: 0 !important;
}

.divTableCell.dense, .divTableHead.dense {
  /*padding : 4px;*/
}
</style>
